import React from "react";
import { Link } from "react-router-dom";
import { Newnav } from "./Newnav";
import "./services.css";
// import Engagements from "./images/service_engagement.JPG";
import Proposal from "./images/service_proposal.JPG";
import Wedding from "./images/service_wedding.JPG";

const sections = [
  {
    title: "PROPOSAL/ENGAGEMENT",
    desc: "From the anticipation to the 'yes', we’ll capture every unforgettable moment.",
    img: Proposal,
  },
  {
    title: "WEDDING",
    desc: "Your love story, beautifully documented from the first look to the last dance.",
    img: Wedding,
  },
];

const ServicesPage = () => {
  return (
    <div className="services-page">
      <Newnav />
      <div className="services-list">
        <div className="services-header">
          <h1>SERVICES</h1>
        </div>
        {sections.map((s) => {
          const slugOriginal = s.title.toLowerCase();
          const slug =
            slugOriginal === "proposal/engagement" ? "proposal" : slugOriginal;
          return (
            <section className="service" key={s.title}>
              <div className="service-media">
                <Link to={`/services/${slug}`}>
                  <img src={s.img} alt={s.title} />
                </Link>
              </div>
              <div className="service-content">
                <div className="content-inner">
                  <h2>
                    <Link to={`/services/${slug}`}>{s.title}</Link>
                  </h2>
                  <p>{s.desc}</p>
                </div>
              </div>
            </section>
          );
        })}
      </div>
    </div>
  );
};

export { ServicesPage };
